"use strict";

exports.__esModule = true;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuerySubscription = function () {
  function QuerySubscription(environment, operation, cacheConfig) {
    var _this = this;

    (0, _classCallCheck3.default)(this, QuerySubscription);

    this.onChange = function (snapshot) {
      _this.updateReadyState({
        error: null,
        props: snapshot.data,
        retry: _this.retry
      });
    };

    this.retry = function () {
      _this.dispose();
      _this.fetch();
    };

    this.environment = environment;
    this.operation = operation;
    this.cacheConfig = cacheConfig;

    this.fetchPromise = null;
    this.selectionReference = null;
    this.pendingRequest = null;
    this.rootSubscription = null;

    this.readyState = {
      error: null,
      props: null,
      retry: null
    };

    this.listeners = [];

    this.relayContext = {
      environment: this.environment,
      variables: this.operation.variables
    };
  }

  QuerySubscription.prototype.fetch = function fetch() {
    var _this2 = this;

    if (!this.fetchPromise) {
      this.fetchPromise = new _promise2.default(function (resolve) {
        var snapshot = void 0;

        _this2.selectionReference = _this2.retain();

        _this2.pendingRequest = _this2.environment.execute({
          operation: _this2.operation,
          cacheConfig: _this2.cacheConfig
        }).finally(function () {
          _this2.pendingRequest = null;
        }).subscribe({
          next: function next() {
            if (snapshot) {
              return;
            }

            snapshot = _this2.environment.lookup(_this2.operation.fragment);

            _this2.onChange(snapshot);

            _this2.rootSubscription = _this2.environment.subscribe(snapshot, _this2.onChange);

            resolve();
          },

          error: function error(_error) {
            _this2.updateReadyState({
              error: _error,
              props: null,
              // FIXME: Use default readyState when retrying.
              retry: _this2.retry
            });

            resolve();
          }
        });
      });
    }

    return this.fetchPromise;
  };

  QuerySubscription.prototype.updateReadyState = function updateReadyState(readyState) {
    this.readyState = readyState;

    this.listeners.forEach(function (listener) {
      listener(readyState);
    });
  };

  QuerySubscription.prototype.subscribe = function subscribe(listener) {
    this.listeners.push(listener);
  };

  QuerySubscription.prototype.unsubscribe = function unsubscribe(listener) {
    this.listeners = this.listeners.filter(function (item) {
      return item !== listener;
    });
  };

  QuerySubscription.prototype.retain = function retain() {
    return this.environment.retain(this.operation.root);
  };

  QuerySubscription.prototype.dispose = function dispose() {
    this.fetchPromise = null;

    if (this.selectionReference) {
      this.selectionReference.dispose();
    }

    if (this.pendingRequest) {
      this.pendingRequest.unsubscribe();
    }

    if (this.rootSubscription) {
      this.rootSubscription.dispose();
    }
  };

  return QuerySubscription;
}();

exports.default = QuerySubscription;
module.exports = exports["default"];